<!--
 * @Description: 
 * @Date: 2019-07-31 16:11:15
-->
<template>
  <div class="relativeBox">
    <tag />
    <YshTaskList :projectType="projectType"></YshTaskList>
    <!-- <TaskRecord :taxCollectionPattern="0" :projectType="1" /> -->
  </div>
</template>
<script>
import { mapState } from 'vuex';
import tag from '@/components/Common/tag.vue';
import YshTaskList from '@/components/Task/AcceptList';
import TaskRecord from '@/components/Task/TaskRecord/index.vue';
export default {
  components: { YshTaskList, tag, TaskRecord },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      projectType: state => state.homeProject.projectType
    })
  }
};
</script>
<style lang="scss" scoped>
.relativeBox {
  ::v-deep {
    .table-box {
      margin: 0;
      padding-top: 45px;
    }
  }
}
</style>
